// @flow
import 'whatwg-fetch';
import { authInstance } from '../firebase';

export const fetchWithToken = async (url: string, options: any): any =>
  fetch(
    url,
    Object.assign(
      {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Basic ${btoa(
            `firebase-mobile:${await authInstance.currentUser.getIdToken()}`
          )}`,
        },
      },
      options
    )
  );
export const getAvaBackendEndpoint = (): string =>
  localStorage.getItem('avaBackendUrl') || process.env.AVA_BACKEND_URL || '';

export const getScribeBackendEndpoint = (): string =>
  localStorage.getItem('scribeBackendUrl') ||
  process.env.SCRIBE_BACKEND_URL ||
  '';

export const getSubscriptionBackendEndpoint = (): string =>
  process.env.SUBSCRIPTION_API_URL || '';

export const getSaasBackendEndpoint = (): string =>
  localStorage.getItem('saasBackendUrl') || process.env.SAAS_BACKEND_URL || '';

export const getDefaultBackendEndpoint = (): string => {
  switch (localStorage.getItem('scribe_mode')) {
    case 'web':
      return getAvaBackendEndpoint();
    case 'scribe':
    default:
      return getScribeBackendEndpoint();
  }
};

export const getSearchValueFromString = (
  searchString: string,
  key: string,
  _default: Object
) => {
  if (!searchString) {
    return _default;
  }
  const items = searchString.split('&').map(s => s.split('='));
  // eslint-disable-next-line
  for (const item of items) {
    if (key === item[0]) {
      return item[1];
    }
  }
  return _default;
};

export const getSearchValue = (
  window: Object,
  key: string,
  _default: Object
) => {
  const searchString = (window.location.hash.slice(2) || '').split('?')[1];
  return getSearchValueFromString(searchString, key, _default);
};

export const setSearchValue = (window: Object, key: string, value: string) => {
  const hashString = window.location.hash || '#/';
  const searchString = hashString.split('?')[1];
  const preSearchString = hashString.split('?')[0];
  const items = (searchString || '').split('&').map(s => s.split('='));
  let str = '';
  // eslint-disable-next-line
  for (let item of items) {
    if (item.length === 2 && key !== item[0]) {
      str += `${item[0]}=${item[1]}&`;
    }
  }
  str += `${key}=${value}&`;
  window.location.replace(`${preSearchString}${str ? '?' : ''}${str}`);
};

export const clearSearchValue = (window: Object, key: string) => {
  const hashString = window.location.hash || '#/';
  const searchString = hashString.split('?')[1];
  const preSearchString = hashString.split('?')[0];
  if (!searchString) {
    return;
  }
  const items = searchString.split('&').map(s => s.split('='));
  let str = '';
  // eslint-disable-next-line
  for (let item of items) {
    if (item.length === 2 && key !== item[0]) {
      str += `${item[0]}=${item[1]}&`;
    }
  }
  window.location.replace(`${preSearchString}${str ? '?' : ''}${str}`);
};

const initBackend = getSearchValue(window, 'endpoint', undefined);
if (initBackend) {
  localStorage.setItem('avaBackendUrl', initBackend);
}

export const backends = {
  production: {
    url: 'https://scribe.ava.me',
  },
  playground: {
    url: 'https://scribe-playground.ava.me',
  },
  local: {
    url: 'http://localhost:5000',
  },
};

export const updateBackend = (backendId: string) => {
  localStorage.setItem('scribeBackendUrl', backends[backendId].url);
  window.location.replace('/');
};

export const updateBackendAva = (backendId: string, backendsAva: Object) => {
  localStorage.setItem('avaBackendUrl', backendsAva[backendId].url);
  window.location.replace('/');
};
